import { useEffect, useState } from "react";
export var useIsMobile = function (breakpoint) {
    if (breakpoint === void 0) { breakpoint = 768; }
    var _a = useState(typeof window !== "undefined" ? window.innerWidth <= breakpoint : false), isMobile = _a[0], setIsMobile = _a[1];
    useEffect(function () {
        var debounce;
        var handleResize = function () {
            clearTimeout(debounce);
            debounce = setTimeout(function () {
                setIsMobile(window.innerWidth <= breakpoint);
            }, 150);
        };
        window.addEventListener("resize", handleResize);
        return function () { return window.removeEventListener("resize", handleResize); };
    }, [breakpoint]);
    return isMobile;
};
